var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v(" "+_vm._s(_vm.$t('redemption-history-reference-id-label'))+" "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.referenceId))]),_vm._v(" "+_vm._s(_vm.$t('redemption-history-reference-id-helper'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }